import React from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from '@/components/ui/sonner';
import { queryClient } from '@/core/api';
import { RealtimeProvider } from '@/core/realtime';

/**
 * App-wide non-visual providers: TanStack Query, the realtime connection and
 * toast notifications. Mount high in the tree, inside the Router. The
 * 401-handler is wired by AuthProvider (it needs router + session access).
 * RealtimeProvider sits inside QueryClientProvider because its consumers write
 * to the query cache.
 */
export const AppProviders: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <QueryClientProvider client={queryClient}>
      <RealtimeProvider>{children}</RealtimeProvider>
      <Toaster />
    </QueryClientProvider>
  );
};
